import load from "@/common/load";
import {axiosPost} from "@/layouts/admin-sidebar/requstDev";
import api from "@/service/api";
import userStore from "@/stores/user";
import tagStore from "@/stores/tagStore";
import {createVNode, nextTick, reactive, ref, toRefs, watch} from "vue";
import {Modal} from "ant-design-vue";
import {ExclamationCircleOutlined} from "@ant-design/icons-vue";

/**
 *@Author  ahuan
 *@Description
 *@Date 2024/6/24
 **/
export default function () {
    // 无归属列表
    let noTagList = ref([]);

    let user = userStore();
    let tag = tagStore();

    let showArr = ref([]);

    let initList = async () => {
        try {
            load.loading("获取无归属列表...")
            let result = await axiosPost(api.getNoTagList, {
                userId: user.userId,
            })
            load.loaded();
            if (result.result === '1') {
                if (result.data.length) {
                    result.data.sort((a, b) => {
                        return a.localeCompare(b)
                    })
                    noTagList.value = [...result.data];
                    showArr.value = [];
                    for (let i = 0; i < result.data.length; i++) {
                        showArr.value.push({
                            uniqueCode: result.data[i],
                            online: 1
                        })
                    }
                }else{
                    noTagList.value = [];
                    showArr.value = [];
                }

            } else {
                load.error(result.msg);
            }
        } catch (e) {
            load.error("获取无归属列表失败...")
        }
    }
    initList();
    let STATE = ref(false);
    const state = reactive({
        indeterminate: true,
        checkAll: false,
        addList: [],
    });
    const onCheckAllChange = e => {
        Object.assign(state, {
            addList: e.target.checked ? noTagList.value : [],
            indeterminate: false,
        });
    };
    // 无归属列表添加标签
    let addTags = () => {
        STATE.value = !STATE.value;
        if (STATE.value === false) return;
        console.log(state.addList.value)
    }
    watch(() => state.addList,
        val => {
            state.indeterminate = !!val.length && val.length < noTagList.value.length;
            state.checkAll = val.length === noTagList.value.length;
        })

    // 批量添加标签
    let addInBulk = (item) => {
        console.log(item)
        Modal.confirm({
            content: `是否确定将这${state.addList.length}个设备添加到“${item.tagName}”标签里面`,
            icon: createVNode(ExclamationCircleOutlined),
            async onOk() {
                load.loading("添加中...")
                try {
                    let result = await axiosPost(api.insertDevTage, {
                        userId: user.userId,
                        data: {
                            uniqueCodes: state.addList,
                            tagId: item.tagId
                        },
                    })
                    if (result.result === '1') {
                        load.success("添加成功...")
                        initList();
                    } else {
                        load.error(result.msg);
                    }
                } catch (e) {
                    load.error(`给标签${item.tagName}添加设备失败...`)
                }
            },
            cancelText: '取消',
            onCancel() {
            },
        });
    }
    // 新标签名称
    let newTagName = ref("");
    let inputVisible = ref(false);
    // handleInputConfirm
    let handleInputConfirm = () => {
        if (!newTagName.value) {
            inputVisible.value = false;
            return
        }
        Modal.confirm({
            content: `是否确定将这${state.addList.length}个设备添加到“${newTagName.value}”新标签里面`,
            icon: createVNode(ExclamationCircleOutlined),
            async onOk() {
                load.loading("添加中...")
                try {
                    let result = await axiosPost(api.insertDevNewTage, {
                        userId: user.userId,
                        data: {
                            uniqueCodes: state.addList,
                            newTagName: newTagName.value
                        },
                    })
                    inputVisible.value = false;
                    newTagName.value = "";
                    if (result.result === '1') {
                        load.success("添加成功...")
                        tag.initTagList();
                        initList();
                        console.log(result)
                    } else {
                        load.error(result.msg);
                    }
                } catch (e) {
                    load.error(`给新标签${newTagName.value}添加设备失败...`)
                }
            },
            cancelText: '取消',
            onCancel() {
            },
        });
    }
    let inputRef = ref();
    const showInput = () => {
        inputVisible.value = true;
        nextTick(() => {
            inputRef.value.focus();
        });
    };
    return {
        noTagList,
        initList,
        addTags,
        STATE,
        ...toRefs(state),
        onCheckAllChange,
        addInBulk,
        newTagName,
        handleInputConfirm,
        inputVisible,
        showInput,
        inputRef,
        showArr
    }
}
